<section>

    <h2>FAQs</h2>

    <div class="faq">
        <h3>How to override default styles?</h3>

        <ol>
            <li>Download the css <a href="./svelte-tags-input-css.css" download>svelte-tags-input-css.css</a></li>
			<li>Create a container for the tag with custom class</li>
			<li>Apply your styles in the ways presented below</li>
        </ol>

        <div class="code-block">
<pre class="language-js line-numbers"><code>&lt;div class="my-custom-class"&gt;
	&lt;Tags /&gt;
&lt;/div&gt;</code></pre>

					<pre class="language-css line-numbers"><code>.my-custom-class :global(.svelte-tags-input-tag) &#123;
	background:blue;
&#125;
							
.my-custom-class :global(.svelte-tags-input-layout) &#123;
	background:yellow;
&#125;</code></pre>
        </div>

        <p>A <b>.focus</b> class is available in case you want to override the input focus style.</p>

        <div class="code-block">
<pre class="language-js line-numbers"><code>&lt;div class="my-custom-class"&gt;
	&lt;Tags /&gt;
&lt;/div&gt;</code></pre>

					<pre class="language-css line-numbers"><code>.my-custom-class :global(.svelte-tags-input-tag.focus), .my-custom-class :global(.svelte-tags-input:focus) &#123;
	background:blue;
&#125;;</code></pre>
        </div>
    </div>

    <div class="faq">
        <h3>How to reset tags input?</h3>

        <p>In response to the request <a href="https://github.com/agustinl/svelte-tags-input/issues/7" target="_blank" rel="noopener noreferrer" class="text-yellow-700 font-medium hover:text-yellow-600">#7</a> for a way to reset the input after submitting a form, for example:</p>

        <div class="code-block">
<pre class="language-js line-numbers"><code>import Tags from "svelte-tags-input";

let tags = [];

function submitForm(event) &#123;
    tags = [];
&#125;</code></pre>

				<pre class="language-js line-numbers"><code>&lt;Tags
	tags=&#123;tags&#125;
/&gt;

&lt;button on:click=&#123;submitForm&#125;/&gt;Submit&lt;/button/&gt;</code></pre>
        </div>
    </div>

    <div class="faq">
        <h3>How to initialize with tags?</h3>

        <p>Start tag input with preloaded tags</p>

        <div class="code-block">
<pre class="language-js line-numbers"><code>import Tags from "svelte-tags-input";

let tags = ["start", "with", "this", "tags"];</code></pre>

				<pre class="language-js line-numbers"><code>&lt;Tags
	tags=&#123;tags&#125;
/&gt;</code></pre>
        </div>
    </div>

</section>